import { useClientCategories } from "api/Client/category";
import NavigationCard from "components/ClientLayoutPages/NavigationCard/NavigationCard";
import NavigationCardContainer from "components/ClientLayoutPages/NavigationCard/NavigationCardContainer";
import SkeletonList from "components/SkeletonList/SkeletonList";
import useParam from "Hooks/useParam";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";

export default function Categories() {
  const categoryId = useParam("categoryId");
  const {
    data: categories,
    isLoading: categoriesIsLoading,
    isSuccess: categoriesIsSuccess,
    isError: categoriesIsError,
  } = useClientCategories(1);

  if (categoriesIsError) return <h1> خطأ z-500 </h1>;

  return (
    <div className="w-full max-w-6xl mx-auto  bg-blue-500_ p-4 mb-4">
      <div className="text-white font-bold_ text-md md:text-xl flex gap-1 flex-wrap">
        <Link to={""} className="duration-200 hover:text-mainLight">
          سحب
        </Link>
        {/* {categoriesIsSuccess && (
          <NestedNavigation data={categories.data.navigate} />
        )} */}
      </div>
      {categories?.data?.currentCategory?.description && (
        <div className="bg-zinc-800 p-4 text-white rounded-md my-4">
          {categories.data.currentCategory.description}
        </div>
      )}
      <h1 className="text-white mb-4 text-center text-xl  py-2 px-4 rounded-md shadow-md">
        اختر طريقة السحب
      </h1>
      <div className="mt-4 w-full">
        {categoriesIsLoading && <SkeletonList number={8} />}
        {categoriesIsSuccess && (
          <NavigationCardContainer>
            {categories.data.categories.map((category) => (
              <NavigationCard
                key={category.id}
                {...{ ...category, link: `?categoryId=${category.id}` }}
              />
            ))}
            {categories.data.products.map((product) => (
              <NavigationCard
                key={product.id}
                {...{
                  ...product,
                  link: `/control-panel/product?productId=${product.id}`,
                }}
              />
            ))}
          </NavigationCardContainer>
        )}
      </div>
    </div>
  );
}

const NestedNavigation = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <Link
        to={`?categoryId=${data.id}`}
        className="text-md duration-200 hover:text-yellow-500 flex gap-1 items-center"
      >
        <IoIosArrowBack className="text-yellow-500" />
        {data.name}
      </Link>
      {data.navigate && <NestedNavigation data={data.navigate} />}
    </>
  );
};
